// import React, { useState } from 'react';
// import { QueryClient, QueryClientProvider, useQuery, useMutation } from 'react-query';
// import DepositService from './DepositService';
// import DepositContext from './DepositContext';

// const queryClient = new QueryClient();

// const DepositProvider = ({ children }) => {
//   const [filterStatus, setFilterStatus] = useState('all');

//   const fetchDeposits = async () => {
//     const { data } = await DepositService.getDeposits({ status: filterStatus });
//     return data;
//   };

//   const fetchNotifications = async () => {
//     const { data } = await DepositService.getAdminNotifications();
//     return data;
//   };

//   const fetchDepositById = async (id) => {
//     const { data } = await DepositService.fetchDepositById(id);
//     return data;
//   };

//   const { data: deposits, refetch: refetchDeposits } = useQuery({
//     queryKey: ['deposits', filterStatus],
//     queryFn: fetchDeposits,
//   });


//   const { data: depositsdetails, refetch: refetchDepositsdetails } = useQuery({
//     queryKey: ['depositsdetails', filterStatus],
//     queryFn: fetchDepositById,
//   });


//   const { data: notifications, refetch: refetchNotifications } = useQuery({
//     queryKey: ['notifications'],
//     queryFn: fetchNotifications,
//   });

//   const mutationUpdate = useMutation({
//     mutationFn: ({ id, deposit }) => DepositService.updateDeposit(id, deposit),
//     onSuccess: () => {
//       queryClient.invalidateQueries(['deposits']);
//     },
//   });


//   const mutationUpdateregect = useMutation({
//     mutationFn: ({ id, deposit }) => DepositService.updateDepositregected(id, deposit),
//     onSuccess: () => {
//       queryClient.invalidateQueries(['deposits']);
//     },
//   });


//   const mutationDelete = useMutation({
//     mutationFn: id => DepositService.deleteDeposit(id),
//     onSuccess: () => {
//       queryClient.invalidateQueries(['deposits']);
//     },
//   });

//   const addDeposit = async (deposit) => {
//     await mutationUpdate.mutateAsync({ id: deposit._id, deposit });
//   };

//   const deleteDeposit = async (id) => {
//     await mutationDelete.mutateAsync(id);
//   };

//   const updateDeposit = async (id, deposit) => {
//     await mutationUpdate.mutateAsync({ id, deposit });
//   };
// const updateDepositregected = async (id, deposit) => {
//     await mutationUpdateregect.mutateAsync({ id,deposit});
// }
//   return (
//     <QueryClientProvider client={queryClient}>
//       <DepositContext.Provider value={{
//         deposits,
//         notifications,
//         addDeposit,
//         fetchDepositById,
//         refetchDepositsdetails,
//         refetchDeposits,
//         refetchNotifications,
//         deleteDeposit,
//         updateDeposit,
//         filterStatus,
//         updateDepositregected,
//         setFilterStatus,
//       }}>
//         {children}
//       </DepositContext.Provider>
//     </QueryClientProvider>
//   );
// };

// export default DepositProvider;



// import React, { useState } from 'react';
// import { QueryClient, QueryClientProvider, useQuery, useMutation } from 'react-query';
// import DepositService from './DepositService';
// import DepositContext from './DepositContext';

// const queryClient = new QueryClient();

// const DepositProvider = ({ children }) => {
//   const [filterStatus, setFilterStatus] = useState('all');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [subcategoryId, setSubcategoryId] = useState('');

//   const fetchDeposits = async () => {
//     const { data } = await DepositService.getDeposits({
//       status: filterStatus,
//       subcategoryId,
//       page: currentPage,
//     });
//     return data;
//   };

//   const fetchNotifications = async () => {
//     const { data } = await DepositService.getAdminNotifications();
//     return data;
//   };

//   const fetchDepositById = async (id) => {
//     const { data } = await DepositService.fetchDepositById(id);
//     return data;
//   };

//   const { data: deposits, refetch: refetchDeposits } = useQuery(['deposits', filterStatus, subcategoryId, currentPage], fetchDeposits);

//   const mutationDelete = useMutation(id => DepositService.deleteDeposit(id), {
//     onSuccess: () => {
//       refetchDeposits();
//     },
//   });

//   const mutationUpdate = useMutation(({ id, status }) => DepositService.updateDeposit(id, { status }), {
//     onSuccess: () => {
//       refetchDeposits();
//     },
//   });

//   return (
//     <DepositContext.Provider
//       value={{
//         deposits,
//         deleteDeposit: mutationDelete.mutate,
//         updateDeposit: (id, status) => mutationUpdate.mutate({ id, status }),
//         updateDepositregected: (id, status) => mutationUpdate.mutate({ id, status }),
//         setFilterStatus,
//         filterStatus,
//         fetchDeposits,
//         setSubcategoryId,
//         currentPage,
//         setCurrentPage,
//       }}
//     >
//       {children}
//     </DepositContext.Provider>
//   );
// };

// const AppProvider = ({ children }) => (
//   <QueryClientProvider client={queryClient}>
//     <DepositProvider>
//       {children}
//     </DepositProvider>
//   </QueryClientProvider>
// );

// export default AppProvider;


import React, { useState } from 'react';
import { QueryClient, QueryClientProvider, useQuery, useMutation } from 'react-query';
import DepositService from './DepositService';
import DepositContext from './DepositContext';
import { getSubcategories } from '../../../api/subcategory';

const queryClient = new QueryClient();

const DepositProvider = ({ children }) => {
  const [filterStatus, setFilterStatus] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [subcategoryId, setSubcategoryId] = useState('');

  const fetchDeposits = async () => {
    const { data } = await DepositService.getDeposits({
      status: filterStatus,
      subcategoryId,
      page: currentPage,
    });
    return data;
  };

  const fetchSubcategories = async () => {
    const { data } = await getSubcategories();
    return data;
  };

  const fetchNotifications = async () => {
    const { data } = await DepositService.getAdminNotifications();
    return data;
  };

  const { data: deposits, refetch: refetchDeposits } = useQuery(['deposits', filterStatus, subcategoryId, currentPage], fetchDeposits);
  const { data: subcategories, refetch: refetchSubcategories } = useQuery('subcategories', fetchSubcategories);

  const mutationDelete = useMutation(id => DepositService.deleteDeposit(id), {
    onSuccess: () => {
      refetchDeposits();
    },
  });

  const mutationUpdate = useMutation(({ id, status }) => DepositService.updateDeposit(id, { status }), {
    onSuccess: () => {
      refetchDeposits();
    },
  });
  const mutationUpdateregect = useMutation({
    mutationFn: ({ id, deposit }) => DepositService.updateDepositregected(id, deposit),
    onSuccess: () => {
      queryClient.invalidateQueries(['deposits']);
    },
  });


  return (
    <DepositContext.Provider
      value={{
        deposits,
        subcategories,
        deleteDeposit: mutationDelete.mutate,
        updateDeposit: (id, status) => mutationUpdate.mutate({ id, status }),
        updateDepositregected: (id, status) => mutationUpdateregect.mutate({ id, status }),
        setFilterStatus,
        filterStatus,
        fetchDeposits,
        setSubcategoryId,
        subcategoryId,
        currentPage,
        setCurrentPage,
        refetchSubcategories,
      }}
    >
      {children}
    </DepositContext.Provider>
  );
};

const AppProvider = ({ children }) => (
  <QueryClientProvider client={queryClient}>
    <DepositProvider>
      {children}
    </DepositProvider>
  </QueryClientProvider>
);

export default AppProvider;
